module.exports = __webpack_public_path__ + "img/British Columbia.f396f49e.svg";